
export { LucideIcon } from "/codebuild/output/src594262572/src/packages/shared-components/src/components/LucideIcon.tsx"